import React from 'react';

// Hooks
import { useTranslation } from 'Shared/utils/hooks/use-translation';

// Type
import { CalendarMeeting } from 'Shared/types/CalendarMeeting.type';

// Utils
import { handleLaunchExternalLink } from 'Shared/utils/external-link';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpButton } from 'Wpds/components/button';

type Props = {
  event: CalendarMeeting;
  onClick?: Function;
};

const DayEventConferenceUrl = ({ event, onClick }: Props) => {
  const { tr } = useTranslation();

  const handleClick = () => {
    if (onClick) onClick();
    handleLaunchExternalLink({ href: event.conferenceUrl });
  };

  if (!event.conferenceUrl) return null;

  return (
    <WpButton size="sm" color="gray" variant="secondary" onClick={handleClick}>
      <WpIcon size="sm" name="video" />
      {tr('perform.calendar_meetings.day_event.join_video_call')}
    </WpButton>
  );
};

export default DayEventConferenceUrl;
